import { Header } from "@/components/store/Header";
import { PincodeDialog } from "@/components/store/PincodeDialog";
import { CartSheet } from "@/components/store/CartSheet";
import { useStore } from "@/context/StoreContext";
import { WhatsAppFab } from "@/components/store/WhatsApp";

export const StoreShell = ({ children }) => {
  const { config } = useStore();
  return (
    <div className="min-h-screen bg-[#F9F8F4] flex flex-col">
      {config?.notice && (
        <div className="bg-accent text-white text-sm text-center px-4 py-2" data-testid="store-notice">{config.notice}</div>
      )}
      <Header />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-stone-200 mt-16" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10 grid gap-6 sm:grid-cols-3 text-sm text-stone-600">
          <div className="flex gap-3">
            <img src="/images/logo.jpg" alt="Mukti Fresh Vegetable" className="w-14 h-14 rounded-full object-cover shrink-0" />
            <div>
              <p className="font-display text-2xl text-primary font-semibold">Mukti Fresh Vegetable</p>
              <p className="mt-1">Our own stock. Our own riders. Same-day delivery in select Vadodara zones.</p>
            </div>
          </div>
          <div>
            <p className="text-xs tracking-[0.1em] uppercase font-bold text-stone-500 mb-2">Policy</p>
            <p>No substitutions. Unavailable items are removed and refunded the same day.</p>
          </div>
          <div>
            <p className="text-xs tracking-[0.1em] uppercase font-bold text-stone-500 mb-2">Support</p>
            <a href={`tel:+91${config?.support_phone}`} className="font-semibold text-primary" data-testid="support-phone">+91 {config?.support_phone}</a>
            <p className="mt-1" data-testid="store-address">{config?.store_address}</p>
          </div>
        </div>
      </footer>
      <PincodeDialog />
      <CartSheet />
      <WhatsAppFab />
    </div>
  );
};
